var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H2V22H22V2ZM15.2977 9.95833L15.75 9.79167V7H8.25V7.41667L8.62688 7.45833C9.19221 7.54167 9.41834 7.91667 9.49372 8.83333C9.60678 10.5833 9.60678 13.7083 9.53141 15.2083C9.45603 16.0833 9.2299 16.5 8.66457 16.5833L8.25 16.625V17H13.0741V16.625L12.5465 16.5833C11.9435 16.5 11.755 16.125 11.6796 15.2083C11.6043 14.5833 11.6043 13.5417 11.6043 12.3333H12.5842C13.2249 12.375 13.5264 12.9167 13.6771 13.75H14.054V10.375H13.6771C13.5264 11.2083 13.2626 11.75 12.5842 11.75L11.6043 11.7917C11.5666 10.1667 11.6043 8.625 11.6796 7.66667H13.1495C14.2802 7.66667 14.9209 8.5 15.2977 9.95833Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFSquare);
export default __webpack_public_path__ + "static/media/icon-f-square.3ab058c0d2f3c760046de38593350b8b.svg";
export { ForwardRef as ReactComponent };